import Error from "components/form/Error";
import InputAreaPrice from "components/form/InputAreaPrice";
import InputAreaPrime from "components/form/InputAreaPrime";
import LabelArea from "components/form/LabelArea";
import React, { useState, useEffect } from "react";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import SelectVehicleCatBasic from "./SelectVehicleCatBasic";

const DynamicFixedItineraryPrice = ({
  setSelectedOptions,
  selectedOptions,
  setDataInput,
  dataInput,
  register,
  trigger,
  errors,
  handleVehicleCategoryChange,
  handleChange,
  readOnly,
  primeAvailable,
}) => {
  const handleClick = () => {
    setDataInput((prevData) => [
      ...prevData,
      {
        ["vehicle_type_" + prevData.length]: "",
        ["rate_" + prevData.length]: "",
        ["prime_" + prevData.length]: "",
      },
    ]);
    // setSelectedOptions((prevOptions) => {
    //   // console.log(prevOptions,'prevOptions');
    //   return [...prevOptions];
    // });
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [primeStates, setPrimeStates] = useState({}); // Tracks is_prime status for each instance
  useEffect(() => {
    setPrimeStates((prevState) => {
      // Create a new state object by preserving existing indices
      const newPrimeStates = { ...prevState };

      dataInput.forEach((item, index) => {
        const vehicleType = item[`vehicle_type_${index}`];

        // Only set prime state if not already set (preserve for "add" mode)
        if (
          !newPrimeStates.hasOwnProperty(index) &&
          vehicleType &&
          primeAvailable?.hasOwnProperty(vehicleType)
        ) {
          newPrimeStates[index] = primeAvailable[vehicleType];
        }
      });

      return newPrimeStates;
    });
  }, [dataInput, primeAvailable]);

  const handlePrimeStatusChange = (index, primeStatus) => {
    setPrimeStates((prevState) => ({
      ...prevState,
      [index]: primeStatus,
    }));
  };
  const handleDelete = (i) => {
    setSelectedOptions((prevOptions) => {
      const deleteVal = dataInput[i][`vehicle_type_${i}`];
      return prevOptions.filter((option) => option !== deleteVal);
    });

    setDataInput((prevData) => {
      const newData = prevData.filter((_, index) => index !== i);

      const reIndexedData = newData.map((item, index) => {
        return {
          [`vehicle_type_${index}`]:
            item[
              Object.keys(item).find((key) => key.startsWith("vehicle_type"))
            ] || "",
          [`rate_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("rate"))] || "",
          [`prime_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("prime"))] ||
            "",
        };
      });

      return reIndexedData;
    });
  };
  const handleDeleteConfirm = () => {
    handleDelete(deleteIndex);
    setShowDeleteModal(false);
  };
  return (
    <div className="col-span-full relative">
      <div className="items-center grid xl:grid-cols-5 lg:grid-cols-1 gap-5 mb-3 col-span-8">
        <div className="hidden xl:block">
          <LabelArea label={"Vehicle Type"} />
        </div>
        <div className="hidden xl:block">
          <LabelArea label={"Price"} />
        </div>
        <div className="hidden xl:block">
          <LabelArea label={"Prime %"} />
        </div>
        {/* <div className="xl:hidden text-center underline underline-offset-8 mb-3">
          Vehicles and Hike
        </div> */}
      </div>
      {dataInput.map((val, i) => (
        <div
          className="items-center grid xl:grid-cols-5 lg:grid-cols-1 gap-5 col-span-8 mb-10"
          key={i}
        >
          <div className="">
            <SelectVehicleCatBasic
              register={register}
              label="Vehicle Type"
              name={`vehicle_type_${i}`}
              selectedVehicle={String(val[`vehicle_type_${i}`])}
              selectedOptions={selectedOptions}
              readOnly={readOnly}
              onChange={(e) => handleVehicleCategoryChange(e, i)}
              onPrimeStatusChange={(primeStatus) =>
                handlePrimeStatusChange(i, primeStatus)
              }
              type="text"
              placeholder={"--Choose--"}
            />
            <Error errorName={errors[`vehicle_type_${i}`]} />
          </div>
          <div className="">
            <InputAreaPrice
              register={register}
              name={`rate_${i}`}
              label="Price"
              type="text"
              maxLength={6}
              readOnly={readOnly}
              value={val[`rate_${i}`]}
              //defaultValue={val[`rate_${i}`]}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder={"Price"}
            />
            <Error errorName={errors[`rate_${i}`]} />
          </div>
          {primeStates[i] ? (
            <div className="">
              <InputAreaPrime
                register={register}
                trigger={trigger}
                name={`prime_${i}`}
                label="Prime"
                type="text"
                value={val[`prime_${i}`]}
                onChangeFunction={(e) => handleChange(e, i)}
                maxLength={2}
                placeholder="0"
              />
              <Error errorName={errors[`prime_${i}`]} />
            </div>
          ) : (
            "Not available"
          )}

          {readOnly ? null : (
            <div className="flex items-center">
              {Object.keys(dataInput).length !== 1 && (
                <button
                  style={{ top: "-10px", outline: "none", color: "grey" }}
                  className="ml-8 outline-none"
                  type="button"
                  aria-label="Remove item"
                  onClick={() => {
                    setDeleteIndex(i);
                    setShowDeleteModal(true);
                  }}
                >
                  X
                </button>
              )}
            </div>
          )}
        </div>
      ))}
      <div className="clear-both"></div>
      {readOnly ? null : (
        <div className="mt-6 lg:mt-1">
          <button
            style={{
              bottom: "-5px",
              color: "#0e9f6e",
              fontSize: "42px",
              outline: "none",
            }}
            className="absolute right-0 outline-none"
            type="button"
            onClick={handleClick}
          >
            +
          </button>
        </div>
      )}

      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
      />
    </div>
  );
};

export default DynamicFixedItineraryPrice;
